import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ComputeRuleComponent } from './compute-rule/compute-rule.component';
import { PerfectScrollbarModule } from '@farris/ui-perfect-scrollbar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComboLookupModule } from '@farris/ui-combo-lookup';
import { DataTableModule } from '@farris/ui-datatable';
import { FarrisDialogModule } from '@farris/ui-dialog';
import { ModalModule, BsModalService } from '@farris/ui-modal';
import { MessagerModule } from '@farris/ui-messager';
import { ComboService } from '@farris/ui-combo-list';
import { NotifyModule } from '@farris/ui-notify';
import { ExpressioneditorComponent } from './expressioneditor/expressioneditor.component';
import { MyMonacoEditorConfig } from './my-monaco-editor/editorconfig';
import { MyMonacoEditorModule } from './my-monaco-editor/my-monaco-editor.module';
import { ExpressionEventService } from './utils/expression-event-service';
import { SplitterModule } from '@farris/ui-splitter';
import { FarrisTabsModule } from '@farris/ui-tabs';
import { PopoverModule } from '@farris/ui-popover';
import { DatagridModule } from '@farris/ui-datagrid';
import { FarrisSidebarModule } from '@farris/ui-sidebar';
import { ExprFuncGridComponent } from './expr-func-grid/expr-func-grid.component';
import { AngularDraggableModule } from '@farris/ui-draggable';
import { ExpressionVarGridComponent } from './expression-var-grid/expression-var-grid.component';
import { ExpressionVarInfoGridComponent } from './expression-var-info-grid/expression-var-info-grid.component';
import { TreeTableModule } from '@farris/ui-treetable';
import { DatagridFilterRowModule } from '@farris/ui-datagrid-filter';
import { ExpressionEntityGridComponent } from './expression-entity-grid/expression-entity-grid.component';
import { ExpressionSmartHelpGridComponent } from './expression-smart-help-grid/expression-smart-help-grid.component';
import { ExpressionEditorLocalePipe } from './utils/expression-editor-locale.pipe';
import { ExpressionService } from './expressionservice';
import { ComputeRuleEditorComponent } from './compute-rule-editor/compute-rule-editor.component';
import { ExpressionSchemaGridComponent } from './deprecated-component/expression-schema-grid.component';
import { ExpressionSchemaInfoGridComponent } from './deprecated-component/expression-schema-info-grid.component';
import { ExpressionEntityInfoGridComponent } from './deprecated-component/expression-entity-info-grid.component';
import { SysManagerUIModule } from '@gsp-sys/sysmgr-ui'
import { HttpService } from "@ecp-caf/caf-common"
import { BasePathService } from '@farris/rtf';

const monacoConfig: MyMonacoEditorConfig = {
  baseUrl: 'assets',
  defaultOptions: { scrollBeyondLastLine: false }
};
@NgModule({
  declarations: [
    ComputeRuleEditorComponent,
    ComputeRuleComponent,
    ExpressioneditorComponent,
    ExprFuncGridComponent,
    ExpressionVarGridComponent,
    ExpressionVarInfoGridComponent,
    ExpressionSchemaGridComponent,
    ExpressionSchemaInfoGridComponent,
    ExpressionEntityGridComponent,
    ExpressionEntityInfoGridComponent,
    ExpressionSmartHelpGridComponent,
    ExpressionEditorLocalePipe
  ],
  imports: [
    PopoverModule,
    CommonModule,
    MyMonacoEditorModule.forRoot(monacoConfig),
    FormsModule,
    ReactiveFormsModule,
    TreeTableModule,
    ComboLookupModule,
    DataTableModule,
    FarrisDialogModule,
    PerfectScrollbarModule,
    HttpClientModule,
    MessagerModule.forRoot(),
    ModalModule.forRoot(),
    NotifyModule,
    SplitterModule,
    FarrisTabsModule,
    DatagridFilterRowModule.forRoot(),
    DatagridModule,
    AngularDraggableModule,
    SysManagerUIModule,
    FarrisSidebarModule
  ],
  entryComponents: [ComputeRuleComponent, ExpressioneditorComponent, ComputeRuleEditorComponent],
  exports: [ComputeRuleComponent, ExpressioneditorComponent, ComputeRuleEditorComponent],
  providers: [ComboService, BsModalService, ExpressionEventService, ExpressionService, HttpClient, HttpService, BasePathService]
})
export class ExpressionModule { }
